import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Flex } from '@stepstone-genesis/components';
import { LeftSideContent } from './components/LeftSideContent/index.js';
import { RightSideContent } from './components/RightSideContent.js';
export const FullscreenTwoStepContent = () => {
    return (_jsxs(Flex, { px: ['spaceS', 'spaceL'], py: ['spaceS2', 'spaceL'], sx: { overflowY: 'auto', minHeight: '100%' }, flxDirection: ['column', 'row'], flxItems: 'stretch', gap: ['unset', 'spaceS'], children: [_jsx(LeftSideContent, {}), _jsx(RightSideContent, {})] }));
};
//# sourceMappingURL=FullscreenTwoStepContent.js.map